export default __webpack_public_path__ + "static/earth-knowledge-1f80a3b9a1c5740b9ab9c7ddaecb25ad.svg";